import PricingMatrix from './PricingMatrix';

export default PricingMatrix;
